import $axios from './api';

export const login = async ({ email, password }) => {
	const { data } = await $axios.post('/v1/auth/login', { email, password });
	return data;
};

export const logout = async () => {
	const { data } = await $axios.post('/v1/auth/logout', {});
	return data;
};

export const getUser = async () => {
	const { data } = await $axios.get('/v1/author/profile');
	return data;
};

export const checkEmail = async (payload) => {
	const { data } = await $axios.post('/v1/auth/checkEmail', payload);
	return data;
};

export const checkRegistrationCode = async ({ email, code }) => {
	const { data } = await $axios.post('/v1/auth/checkRegistrationCode', { email, code });
	return data;
};

export const register = async (registerData) => {
	const { data } = await $axios.post('/v1/author/register', registerData);
	return data;
};

export const update = async (userData) => {
	const { data } = await $axios.post('/v1/author/profile', userData);
	return data;
};

export const forgotPassword = async (email) => {
	const { data } = await $axios.post('/v1/author/forgotPassword', { email });
	return data;
};

export const resetPassword = async ( payload ) => {
	const { data } = await $axios.post('/v1/author/resetPassword', payload );
	return data;
};

export const getQuotaUsage = async () => {
	const { data } = await $axios.get('/v1/author/quota/usage');
	return data;
};

export const ambassadorList = async (payload = {}) => {
	const { data } = await $axios.post('/v1/author/ambassador/list', payload);
	return data;
};